module.exports = __webpack_public_path__ + "static/media/subscriptions - Copy.f7c028ec.jpg";